<!-- Boundary marker for the frozen header area. Outside the scroller so it stays put; see the component SCSS. -->
@if (hasPageHeader()) {
  <div class="page-divider"></div>
}
<!-- `tabindex="0"` is an accessibility requirement, not a stray attribute: a region that scrolls but cannot be
     focused is unreachable for anyone driving the page from the keyboard (axe `scrollable-region-focusable`,
     WCAG 2.1.1). It is the page's whole body, so it needs no `role`/label of its own — the content inside it
     carries the semantics. `.page-scroller` styles the focus ring, since a focusable box with no visible focus
     state would trade one barrier for another. -->
<div class="page-scroller" tabindex="0">
  <div class="page-scroller-content" [class.page-scroller-content--standalone]="!hasPageHeader()">
    <ng-content></ng-content>
  </div>
</div>
